import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Box } from '@mui/material';
import { Truck, UserPen } from 'lucide-react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { OrderConditionsTestIds } from '../../../../../../../utils/testIds/OrderConditions.testIds';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { FreightOrigin } from '../../../../../conditions/orderCondition.types';

interface OrderConditionFreightOriginIndicatorProps {
  origin: FreightOrigin;
  tabIndex?: number;
}

const ORIGIN_CONTENT = {
  [FreightOrigin.MANUAL]: { icon: UserPen, label: LangEnum.ORDER_CONDITION_FREIGHT_MANUAL_ORIGIN },
  [FreightOrigin.AUTOMATIC]: {
    icon: Truck,
    label: LangEnum.ORDER_CONDITION_FREIGHT_AUTOMATIC_ORIGIN,
  },
};

const OrderConditionFreightOriginIndicator = ({
  origin,
  tabIndex,
}: OrderConditionFreightOriginIndicatorProps) => {
  const { translate } = useTranslation();
  const { icon, label: labelKey } = ORIGIN_CONTENT[origin];
  const label = translate(labelKey);

  return (
    <Tooltip TooltipContent={label} tabIndex={tabIndex}>
      <Box
        test-id={OrderConditionsTestIds.FREIGHT_ORIGIN_ICON}
        sx={{ display: 'inline-flex', alignItems: 'center', color: 'text.secondary' }}
      >
        <Icon icon={icon} size="sm" ariaLabel={label} />
      </Box>
    </Tooltip>
  );
};

export default OrderConditionFreightOriginIndicator;
